"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getAccountInfo = getAccountInfo;
exports.refreshToken = refreshToken;
exports.showQBLoginPanel = showQBLoginPanel;
exports.getBrowserParam = getBrowserParam;
exports.onLoginUserSwitch = onLoginUserSwitch;
exports.fetchSession = fetchSession;
exports.setStorage = setStorage;
exports.getStorage = getStorage;
exports.clearStroage = clearStroage;
exports.AegisModule = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));

var _log = require("../utils/log");

var _api = require("../api");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context12; _forEachInstanceProperty(_context12 = ownKeys(Object(source), true)).call(_context12, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context13; _forEachInstanceProperty(_context13 = ownKeys(Object(source))).call(_context13, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Aegis = null;

if (typeof window !== 'undefined') {
  Aegis = require('@tencent/aegis-web-sdk');
}

// 存放在内存中的session
var sessionInfoInDisk;

// promisify 功能并且有timeout, 传Infinity
function promisify(executor) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var p1 = new _promise["default"](function (resolve, reject) {
      var _context;

      executor.apply(void 0, (0, _concat["default"])(_context = [resolve, reject]).call(_context, args));
    }); // 设置Infinity的timeout则直接返回promise

    if (!isFinite(timeout)) {
      return p1;
    }

    var p2 = new _promise["default"](function (resolve, reject) {
      (0, _setTimeout2["default"])(function () {
        reject(new Error("call timeout ".concat(timeout)));
      }, timeout);
    });
    return _promise["default"].race([p1, p2]);
  };
}

function getAccountInfo() {
  return _getAccountInfo.apply(this, arguments);
}

function _getAccountInfo() {
  _getAccountInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var _window2, _window2$browser, _window2$browser$logi, _window3, _window3$x;

    var logName, log;
    return _regenerator["default"].wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            logName = 'getAccountInfo';
            log = new _log.Logger("jsapi-".concat(logName));

            if (!((_window2 = window) !== null && _window2 !== void 0 && (_window2$browser = _window2.browser) !== null && _window2$browser !== void 0 && (_window2$browser$logi = _window2$browser.login) !== null && _window2$browser$logi !== void 0 && _window2$browser$logi.getAccountInfo)) {
              _context3.next = 5;
              break;
            }

            log.log('---start---');
            return _context3.abrupt("return", promisify(window.browser.login.getAccountInfo, Infinity)());

          case 5:
            if (!((_window3 = window) !== null && _window3 !== void 0 && (_window3$x = _window3.x5) !== null && _window3$x !== void 0 && _window3$x.exec)) {
              _context3.next = 8;
              break;
            }

            log.log('---start---', 'x5 exec');
            return _context3.abrupt("return", promisify(function (resolve, reject) {
              var _window4, _window4$x, _window4$x$exec;

              (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$x = _window4.x5) === null || _window4$x === void 0 ? void 0 : (_window4$x$exec = _window4$x.exec) === null || _window4$x$exec === void 0 ? void 0 : _window4$x$exec.call(_window4$x, resolve, reject, 'login', 'getAccountInfo', []);
            })());

          case 8:
            throw Error("".concat(logName, " error: no match jsapi"));

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2);
  }));
  return _getAccountInfo.apply(this, arguments);
}

function refreshToken(_x) {
  return _refreshToken.apply(this, arguments);
}

function _refreshToken() {
  _refreshToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(opt) {
    var _window5, _window5$browser;

    var logName, log;
    return _regenerator["default"].wrap(function _callee3$(_context4) {
      var _context5;

      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            logName = 'refreshToken';
            log = new _log.Logger("jsapi-".concat(logName));

            if (!(!(opt !== null && opt !== void 0 && opt.uin) || !((_window5 = window) !== null && _window5 !== void 0 && (_window5$browser = _window5.browser) !== null && _window5$browser !== void 0 && _window5$browser.login))) {
              _context4.next = 4;
              break;
            }

            throw Error((0, _concat["default"])(_context5 = "".concat(logName, " error: no match jsapi or no uin: ")).call(_context5, opt === null || opt === void 0 ? void 0 : opt.uin));

          case 4:
            log.log('---start---');
            return _context4.abrupt("return", promisify(function (resolve) {
              var _window6, _window6$browser, _window6$browser$logi;

              (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$browser = _window6.browser) === null || _window6$browser === void 0 ? void 0 : (_window6$browser$logi = _window6$browser.login) === null || _window6$browser$logi === void 0 ? void 0 : _window6$browser$logi.refreshToken({
                uin: opt === null || opt === void 0 ? void 0 : opt.uin
              }, resolve);
            })());

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3);
  }));
  return _refreshToken.apply(this, arguments);
}

function showQBLoginPanel() {
  return _showQBLoginPanel.apply(this, arguments);
}

function _showQBLoginPanel() {
  _showQBLoginPanel = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var _window7, _window7$browser, _window7$browser$logi, _window9, _window9$x;

    var loginPanelOpts,
        logName,
        log,
        _window8,
        _window8$browser,
        _window8$browser$logi,
        _args4 = arguments;

    return _regenerator["default"].wrap(function _callee4$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            loginPanelOpts = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
            logName = 'showQBLoginPanel';
            log = new _log.Logger("jsapi-".concat(logName));

            if (!((_window7 = window) !== null && _window7 !== void 0 && (_window7$browser = _window7.browser) !== null && _window7$browser !== void 0 && (_window7$browser$logi = _window7$browser.login) !== null && _window7$browser$logi !== void 0 && _window7$browser$logi.showLoginPanel)) {
              _context6.next = 6;
              break;
            }

            log.log('---start---');
            return _context6.abrupt("return", promisify((_window8 = window) === null || _window8 === void 0 ? void 0 : (_window8$browser = _window8.browser) === null || _window8$browser === void 0 ? void 0 : (_window8$browser$logi = _window8$browser.login) === null || _window8$browser$logi === void 0 ? void 0 : _window8$browser$logi.showLoginPanel, Infinity)(loginPanelOpts));

          case 6:
            if (!((_window9 = window) !== null && _window9 !== void 0 && (_window9$x = _window9.x5) !== null && _window9$x !== void 0 && _window9$x.exec)) {
              _context6.next = 9;
              break;
            }

            log.log('---start---', 'x5 exec');
            return _context6.abrupt("return", promisify(function (resolve, reject) {
              var _window10, _window10$x, _window10$x$exec;

              (_window10 = window) === null || _window10 === void 0 ? void 0 : (_window10$x = _window10.x5) === null || _window10$x === void 0 ? void 0 : (_window10$x$exec = _window10$x.exec) === null || _window10$x$exec === void 0 ? void 0 : _window10$x$exec.call(_window10$x, resolve, reject, 'login', 'showLoginPanel', []);
            })());

          case 9:
            throw Error("".concat(logName, " error: no match jsapi"));

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee4);
  }));
  return _showQBLoginPanel.apply(this, arguments);
}

function getBrowserParam() {
  return _getBrowserParam.apply(this, arguments);
}

function _getBrowserParam() {
  _getBrowserParam = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var _window11, _window11$browser, _window11$browser$app;

    var logName, log, _window12, _window12$browser, _window12$browser$app;

    return _regenerator["default"].wrap(function _callee5$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            logName = 'getBrowserParam';
            log = new _log.Logger("jsapi-".concat(logName));

            if (!((_window11 = window) !== null && _window11 !== void 0 && (_window11$browser = _window11.browser) !== null && _window11$browser !== void 0 && (_window11$browser$app = _window11$browser.app) !== null && _window11$browser$app !== void 0 && _window11$browser$app.getBrowserParam)) {
              _context7.next = 5;
              break;
            }

            log.log('---start---');
            return _context7.abrupt("return", promisify((_window12 = window) === null || _window12 === void 0 ? void 0 : (_window12$browser = _window12.browser) === null || _window12$browser === void 0 ? void 0 : (_window12$browser$app = _window12$browser.app) === null || _window12$browser$app === void 0 ? void 0 : _window12$browser$app.getBrowserParam)());

          case 5:
            throw Error("".concat(logName, " error: no match jsapi"));

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee5);
  }));
  return _getBrowserParam.apply(this, arguments);
}

function onLoginUserSwitch(callback) {
  var _window, _window$browser, _window$browser$event;

  (_window = window) === null || _window === void 0 ? void 0 : (_window$browser = _window.browser) === null || _window$browser === void 0 ? void 0 : (_window$browser$event = _window$browser.event) === null || _window$browser$event === void 0 ? void 0 : _window$browser$event.onloginUserSwitch(callback !== null && callback !== void 0 ? callback : function () {});
}
/**
 *
 * @param {object} options - 被调服务信息
 * @param {string} options.accountInfo - accountInfo
 * @param {string} options.sessionInfo - sessionInfo
 * @param {string} options.sessionObserver - 回调
 * @param {string} options.extUserInfo - 扩展参数
 * @param {string} options.cgiUrl    - cgi
 * @param {string} options.tryTimes    - 重试次数
 * @param {object} req  - 请求参数实例,为js对象
 */


function fetchSession(_x2) {
  return _fetchSession.apply(this, arguments);
}
/**
 *
 * @param {number} expireTime - 过期时间
 */


function _fetchSession() {
  _fetchSession = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(opt) {
    var _deviceInfo$guid, _ref, _deviceInfo$qua, _res$ext2;

    var aegis, accountInfo, sessionObserver, extUserInfo, _opt$cgiUrl, cgiUrl, _opt$tryTimes, tryTimes, log, deviceInfo, startTime, res, _res$ext, newAccountInfo;

    return _regenerator["default"].wrap(function _callee6$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            aegis = new AegisModule();
            accountInfo = opt.accountInfo, sessionObserver = opt.sessionObserver, extUserInfo = opt.extUserInfo, _opt$cgiUrl = opt.cgiUrl, cgiUrl = _opt$cgiUrl === void 0 ? '' : _opt$cgiUrl, _opt$tryTimes = opt.tryTimes, tryTimes = _opt$tryTimes === void 0 ? 0 : _opt$tryTimes;
            aegis.infoAll({
              location: 'fetchSession start',
              opt: opt
            });
            log = new _log.Logger('fetchSession');

            if ((0, _api.checkHasLogin)(accountInfo)) {
              _context8.next = 10;
              break;
            }

            _context8.next = 7;
            return setStorage(_objectSpread(_objectSpread({}, accountInfo), {}, {
              sa: '',
              sk: ''
            }));

          case 7:
            // 每次set session都会通知observer
            sessionObserver === null || sessionObserver === void 0 ? void 0 : sessionObserver(sessionInfoInDisk);
            log.log('no login', sessionInfoInDisk);
            return _context8.abrupt("return", sessionInfoInDisk);

          case 10:
            log.log('---start---', accountInfo, tryTimes);
            _context8.next = 13;
            return getBrowserParam()["catch"]();

          case 13:
            deviceInfo = _context8.sent;
            // catch后拿不到设备信息暂时不需要处理
            startTime = (0, _now["default"])(); // hippy和H5的fetch接口使用是一致的，

            _context8.next = 17;
            return fetch(cgiUrl, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: (0, _stringify["default"])({
                info: accountInfo !== null && accountInfo !== void 0 ? accountInfo : '',
                guid: (_deviceInfo$guid = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.guid) !== null && _deviceInfo$guid !== void 0 ? _deviceInfo$guid : '',
                qua: (_ref = (_deviceInfo$qua = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.qua2) !== null && _deviceInfo$qua !== void 0 ? _deviceInfo$qua : deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.qua) !== null && _ref !== void 0 ? _ref : '',
                ext: extUserInfo
              }),
              credentials: 'include'
            }).then(function (rsp) {
              return rsp.json();
            })["catch"](function (e) {
              aegis.error({
                location: 'fetchSession fetch error',
                error: e,
                costTime: (0, _now["default"])() - startTime
              });
              log.error("fetch ".concat(cgiUrl), e);
              return {};
            });

          case 17:
            res = _context8.sent;
            aegis.infoAll({
              location: 'fetchSession fetch response',
              res: res,
              costTime: (0, _now["default"])() - startTime
            });

            if (!(res.err_code === 0)) {
              _context8.next = 25;
              break;
            }

            _context8.next = 22;
            return setStorage(_objectSpread(_objectSpread({}, accountInfo), {}, {
              sa: res.sa,
              // 如果取消登陆这里是清空的
              sk: res.sk
            }, (_res$ext = res.ext) !== null && _res$ext !== void 0 ? _res$ext : null));

          case 22:
            // 每次set session都会通知observer
            sessionObserver === null || sessionObserver === void 0 ? void 0 : sessionObserver(sessionInfoInDisk, res);
            log.log('success', sessionInfoInDisk);
            return _context8.abrupt("return", sessionInfoInDisk);

          case 25:
            if (!(res.err_code === 2001 && tryTimes < 3)) {
              _context8.next = 31;
              break;
            }

            log.log('retry', tryTimes);
            _context8.next = 29;
            return refreshToken({
              uin: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.uin
            })["catch"]();

          case 29:
            newAccountInfo = _context8.sent;
            return _context8.abrupt("return", fetchSession({
              accountInfo: newAccountInfo,
              cgiUrl: cgiUrl,
              tryTimes: tryTimes + 1,
              setStorage: setStorage
            }));

          case 31:
            setStorage(_objectSpread(_objectSpread({}, accountInfo), {}, {
              sa: '',
              // 如果取消登陆这里是清空的
              sk: ''
            }, (_res$ext2 = res.ext) !== null && _res$ext2 !== void 0 ? _res$ext2 : null)); // 每次set session都会通知observer

            sessionObserver === null || sessionObserver === void 0 ? void 0 : sessionObserver(sessionInfoInDisk, res);
            log.log('fetchSession error', res);
            return _context8.abrupt("return", sessionInfoInDisk);

          case 35:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee6);
  }));
  return _fetchSession.apply(this, arguments);
}

function setStorage(_x3) {
  return _setStorage.apply(this, arguments);
}
/**
 *
 * @param {object} sessionInfo - session对象
 */


function _setStorage() {
  _setStorage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(sessionInfo) {
    var log, aegis;
    return _regenerator["default"].wrap(function _callee7$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            log = new _log.Logger('setStorage');
            aegis = new AegisModule();
            log.log('---start---');

            if (sessionInfo !== null && sessionInfo !== void 0 && sessionInfo.qbid) {
              _context9.next = 7;
              break;
            }

            log.log('没qbid，setStorage error:', sessionInfo);
            aegis.error({
              location: 'setStorage error, no qbid',
              sessionInfo: sessionInfo
            });
            return _context9.abrupt("return");

          case 7:
            // 写内存，写缓存
            sessionInfoInDisk = sessionInfo;
            log.log('stroageObj:', {
              qbloginSessionInfo: (0, _stringify["default"])(sessionInfo),
              qbloginSessionInfoExpireTime: (0, _now["default"])().toString()
            });
            aegis.infoAll({
              location: 'setStorage success',
              sessionInfo: sessionInfo
            });
            window.localStorage.setItem("".concat(sessionInfo.qbid, "_qblogin_sessionInfo"), (0, _stringify["default"])(sessionInfo));
            window.localStorage.setItem("".concat(sessionInfo.qbid, "_qblogin_sessionInfo_expire_time"), (0, _now["default"])().toString());

          case 12:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee7);
  }));
  return _setStorage.apply(this, arguments);
}

function getStorage(_x4, _x5) {
  return _getStorage.apply(this, arguments);
}

function _getStorage() {
  _getStorage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(accountInfo, expireTime) {
    var _sessionInfoInDisk, _sessionInfoInDisk2;

    var log, aegis, currentTime, stroageTime, sessionInfoFromStorage, sessionInfo;
    return _regenerator["default"].wrap(function _callee8$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            log = new _log.Logger('getStorage');
            aegis = new AegisModule();
            log.log('---start---');

            if (accountInfo !== null && accountInfo !== void 0 && accountInfo.qbid) {
              _context10.next = 7;
              break;
            }

            log.log('没qbid，getStorage eror:', accountInfo);
            aegis.error({
              location: 'getStorage error, no qbid',
              accountInfo: accountInfo,
              expireTime: expireTime
            });
            return _context10.abrupt("return", {});

          case 7:
            log.log('expireTime', expireTime);

            if (!((_sessionInfoInDisk = sessionInfoInDisk) !== null && _sessionInfoInDisk !== void 0 && _sessionInfoInDisk.sa && (_sessionInfoInDisk2 = sessionInfoInDisk) !== null && _sessionInfoInDisk2 !== void 0 && _sessionInfoInDisk2.qbid)) {
              _context10.next = 10;
              break;
            }

            return _context10.abrupt("return", sessionInfoInDisk);

          case 10:
            currentTime = (0, _now["default"])();
            log.log('currentTime', currentTime);
            stroageTime = window.localStorage.getItem("".concat(accountInfo.qbid, "_qblogin_sessionInfo_expire_time"));
            sessionInfoFromStorage = window.localStorage.getItem("".concat(accountInfo.qbid, "_qblogin_sessionInfo"));
            sessionInfo = sessionInfoFromStorage ? JSON.parse(sessionInfoFromStorage) : {};
            log.log('stroageTime', stroageTime);
            log.log('sessionInfo', sessionInfo);

            if (!(sessionInfo !== null && sessionInfo !== void 0 && sessionInfo.sa && sessionInfo !== null && sessionInfo !== void 0 && sessionInfo.sk && stroageTime)) {
              _context10.next = 27;
              break;
            }

            if (!(currentTime - Number(+stroageTime) <= expireTime)) {
              _context10.next = 22;
              break;
            }

            log.log('有缓存且没过期'); // 有缓存且没过期

            aegis.infoAll({
              location: 'getStorage success, 有缓存且没过期',
              sessionInfo: sessionInfo,
              accountInfo: accountInfo
            });
            return _context10.abrupt("return", sessionInfo);

          case 22:
            // 有缓存，但已经过期了，需要清楚缓存
            log.log('有缓存，但已经过期了，需要清楚缓存');
            aegis.infoAll({
              location: 'getStorage success, 有缓存，但已经过期了，需要清楚缓存',
              stroageTime: stroageTime,
              expireTime: expireTime,
              currentTime: currentTime
            });
            clearStroage(accountInfo);
            _context10.next = 30;
            break;

          case 27:
            // 无效缓存
            log.log('无效缓存');
            aegis.infoAll({
              location: 'getStorage fail, 无效缓存',
              sessionInfo: sessionInfo
            });
            clearStroage(accountInfo);

          case 30:
            return _context10.abrupt("return", {});

          case 31:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee8);
  }));
  return _getStorage.apply(this, arguments);
}

function clearStroage(_x6) {
  return _clearStroage.apply(this, arguments);
}

function _clearStroage() {
  _clearStroage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(accountInfo) {
    var log;
    return _regenerator["default"].wrap(function _callee9$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            log = new _log.Logger('clearStroage');
            log.log('---start---');
            sessionInfoInDisk = {};
            window.localStorage.removeItem("".concat(accountInfo.qbid, "_qblogin_sessionInfo_expire_time"));
            window.localStorage.removeItem("".concat(accountInfo.qbid, "_qblogin_sessionInfo"));
            log.log('---end---');

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee9);
  }));
  return _clearStroage.apply(this, arguments);
}

var globalAeigs;

var AegisModule = /*#__PURE__*/function () {
  function AegisModule() {
    (0, _classCallCheck2["default"])(this, AegisModule);
    this.init();
  }

  (0, _createClass2["default"])(AegisModule, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var browserParam;
        return _regenerator["default"].wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!globalAeigs) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return getBrowserParam();

              case 4:
                browserParam = _context2.sent;

                if (Aegis) {
                  globalAeigs = new Aegis({
                    id: 'Ll3pmijm91kyPVyR93',
                    // 项目ID，即上报id
                    uin: browserParam.guid,
                    // 用户唯一 ID（可选）
                    reportApiSpeed: false,
                    // 接口测速
                    reportAssetSpeed: false // 静态资源测速

                  });
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "infoAll",
    value: function infoAll(msg) {
      var _globalAeigs;

      (_globalAeigs = globalAeigs) === null || _globalAeigs === void 0 ? void 0 : _globalAeigs.info((0, _stringify["default"])(msg));
    }
  }, {
    key: "info",
    value: function info(msg) {
      var _globalAeigs2;

      (_globalAeigs2 = globalAeigs) === null || _globalAeigs2 === void 0 ? void 0 : _globalAeigs2.info((0, _stringify["default"])(msg));
    }
  }, {
    key: "error",
    value: function error(msg) {
      var _globalAeigs3;

      (_globalAeigs3 = globalAeigs) === null || _globalAeigs3 === void 0 ? void 0 : _globalAeigs3.report((0, _stringify["default"])(msg));
    }
  }]);
  return AegisModule;
}();

exports.AegisModule = AegisModule;